import poplist from './poplist';
export default poplist;



// WEBPACK FOOTER //
// ./src/components/poplist/index.js